import { useMemo } from 'react';
import { calcOrderShipperTotal } from '@/utilities/calcOrderPricing';

export const useOrderShipperPricing = (orders, circles, backupText = 'We will contact you') => {
    return useMemo(() => {
        const ordersArray = Array.isArray(orders) ? orders : [orders];
        if (circles?.['hide-market-rates']) {
            return 'Contract Rates';
        }
        // Mirror MarketplaceModal's Total Due; require every order priced (no partial multi-order totals).
        if (ordersArray.every((order) => calcOrderShipperTotal(order) > 0)) {
            const total = ordersArray.reduce((sum, order) => sum + calcOrderShipperTotal(order), 0);
            return `$${total.toFixed(2)}`;
        }
        return backupText;
    }, [orders, circles, backupText]);
};
